import { setBuilderToolbar } from '../../../../../Template/config/components/selection/SetBuilder'

export default {
  ...setBuilderToolbar,
  enableExcludeNonNormFilters: {
    ad: false,
    norm: false
  },
  exportButtons: {
    ad: {
      data: true,
      media: true
    },
    norm: {
      data: true,
      media: true
    }
  },
  sortOptions: [
    {
      "value": -1,
      "label": "Alpha Order by Ad Code",
      "field": "ad_code",
      "selected": false
    },
    {
      "value": 100,
      "label": "In-Market Potential Score",
      "selected": true,
      "dataFormat": ".,0"
    },
    {
      "value": 176,
      "label": "Breakthrough Potential Score",
      "selected": false
    },
    {
      "value": 102,
      "label": "Lift to Consideration",
      "selected": false
    },
    {
      "value": 104,
      "label": "Net Actions",
      "selected": false
    },
    {
      "value": 125,
      "label": "Creative Potential Summary Score",
      "selected": false,
      "dataFormat": ".,0"
    },
    {
      "value": 123,
      "label": "Likeability",
      "selected": false
    }
  ]
}
